import { useEffect, useState } from "react"

import { Flex, Space } from "@/atoms"
import { EnterKeyboardHint } from "@/icons"
import { BrowseFilterHint } from "./BrowseFilterHint"
import { EditFilterHint } from "./EditFilterHint"

import styles from "./FooterItem.module.scss"

import type { Token } from "@/organisms/SmartSearch/service/StringService"

export const FooterItem = (props: any) => {
  const { refContainer, displayValues, services, t } = props
  const { StringService, FilterService } = services
  const [text, setIsShow] = useState(t("filter.footer.toStartSearch"))
  const inputIsEmpty = StringService.getTokens().every(
    (token: Token) => token.isEmpty !== false
  )
  const currentToken = StringService.getTokenByCaretPos()
  const isCurrentTokenEmpty = !!currentToken?.isEmpty
  const filter =
    displayValues && FilterService.getFilterByLabel(currentToken?.id)

  useEffect(() => {
    const noFoundEl = refContainer.current?.querySelector(
      '[data-type="no-item-found-smart-search"]'
    )
    const textForNotFoundCase = FilterService.freeSearchAvailable()
      ? t("filter.footer.forFreeSearch")
      : ""
    const nextText = noFoundEl
      ? textForNotFoundCase
      : t("filter.footer.toStartSearch")

    if (nextText !== text) {
      setIsShow(nextText)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [{}])

  const isValueList = filter?.options?.length > 0
  const displayBrowserFilter = !displayValues || isValueList

  return (
    <Space
      className="footer-item-smart-search-ks"
      separator={<span className={styles.divider}>|</span>}
    >
      {displayBrowserFilter && (
        <Flex gap={8} align="center">
          <BrowseFilterHint />
          <span className={styles.text}>{t("filter.hint.browser")}</span>
        </Flex>
      )}
      {!inputIsEmpty && (
        <Flex gap={8} align="center">
          <EditFilterHint />
          <span className={styles.text}>{t("filter.hint.edit")}</span>
        </Flex>
      )}

      <Flex gap={8} align="center">
        <EnterKeyboardHint className={styles.keyboardHint} />
        {(inputIsEmpty || (!displayValues && !isCurrentTokenEmpty)) && (
          <span className={styles.text}>{t("filter.hint.select")}</span>
        )}
        {displayValues && isValueList && (
          <span className={styles.text}>{t("filter.hint.selectAdd")}</span>
        )}
        {displayValues && !isValueList && (
          <span className={styles.text}>{t("filter.hint.add")}</span>
        )}
        {!inputIsEmpty && isCurrentTokenEmpty && (
          <span className={styles.text}>{t("filter.hint.apply")}</span>
        )}
      </Flex>
    </Space>
  )
}
